import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';

import { JITMeetRepository } from '../../../domain/repositories/jit-meet.repository';

import { JITMeetTeleconsultaModel } from '../../../domain/models/jit-meet/jit-meet-teleconsulta.model';
import { JITMeetAccesoPublicoModel } from '../../../domain/models/jit-meet/jit-meet-acceso-publico.model';
import { JITMeetOperacionModel } from '../../../domain/models/jit-meet/jit-meet-operacion.model';
import { JITMeetAccesoProfesionalModel } from '../../../domain/models/jit-meet/jit-meet-acceso-profesional.model';
import { JITMeetIngresoPacienteModel } from '../../../domain/models/jit-meet/jit-meet-ingreso-paciente.model';
import { JITMeetEligibilityModel } from '../../../domain/models/jit-meet/jit-meet-eligibility.model';

import { JITMeetTeleconsultaEntity } from './entities/jit-meet-teleconsulta.entity';
import { JITMeetAccesoPublicoEntity } from './entities/jit-meet-acceso-publico.entity';
import { JITMeetAccesoProfesionalEntity } from './entities/jit-meet-acceso-profesional.entity';
import { JITMeetIngresoPacienteEntity } from './entities/jit-meet-ingreso-paciente.entity';
import { JITMeetEligibilityEntity } from './entities/jit-meet-eligibility.entity';

import { JITMeetTeleconsultaRepositoryMapper } from './mappers/jit-meet-teleconsulta.repository.mapper';
import { JITMeetAccesoPublicoRepositoryMapper } from './mappers/jit-meet-acceso-publico.repository.mapper';
import { JITMeetEligibilityRepositoryMapper } from './mappers/jit-meet-eligibility.repository.mapper';

@Injectable()
export class JITMeetImplementationRepository extends JITMeetRepository {
  private readonly url =
    `${environment.baseUrl}/JITMeet/atenciones`;

  private readonly mapper =
    new JITMeetTeleconsultaRepositoryMapper();

  private readonly accesoPublicoMapper =
    new JITMeetAccesoPublicoRepositoryMapper();

  private readonly eligibilityMapper =
    new JITMeetEligibilityRepositoryMapper();

  constructor(
    private readonly http: HttpClient
  ) {
    super();
  }

  override getEligibility(
    idAtencion: string
  ): Observable<JITMeetEligibilityModel> {
    return this.http
      .get<JITMeetEligibilityEntity>(
        `${this.url}/${idAtencion}/elegibilidad`
      )
      .pipe(
        map((response) =>
          this.eligibilityMapper.mapFrom(response)
        )
      );
  }

  override getByAtencion(
    idAtencion: string
  ): Observable<JITMeetTeleconsultaModel> {
    return this.http
      .get<JITMeetTeleconsultaEntity>(
        `${this.url}/${idAtencion}`
      )
      .pipe(
        map((response) =>
          this.mapper.mapFrom(response)
        )
      );
  }

  override createOrGet(
    idAtencion: string
  ): Observable<JITMeetTeleconsultaModel> {
    return this.http
      .post<JITMeetTeleconsultaEntity>(
        `${this.url}/${idAtencion}`,
        null
      )
      .pipe(
        map((response) =>
          this.mapper.mapFrom(response)
        )
      );
  }

  override getAccesoProfesional(
    idAtencion: string
  ): Observable<JITMeetAccesoProfesionalModel> {
    return this.http.get<JITMeetAccesoProfesionalEntity>(
      `${this.url}/${idAtencion}/acceso-profesional`
    );
  }

  override ingresarPaciente(
    identificador: string
  ): Observable<JITMeetIngresoPacienteModel> {
    return this.http.post<JITMeetIngresoPacienteEntity>(
      `${environment.baseUrl}/JITMeet/accesos/${identificador}/ingresar`,
      null,
      {
        headers: {
          'No-Auth': 'True',
        },
      }
    );
  }

  override enviarCorreoPaciente(
    idAtencion: string
  ): Observable<JITMeetOperacionModel> {
    return this.http.post<JITMeetOperacionModel>(
      `${this.url}/${idAtencion}/acceso-paciente/enviar`,
      null
    );
  }

  override getAccesoPublico(
    identificador: string
  ): Observable<JITMeetAccesoPublicoModel> {
    return this.http
      .get<JITMeetAccesoPublicoEntity>(
        `${environment.baseUrl}/JITMeet/accesos/${identificador}`,
        {
          headers: {
            'No-Auth': 'True',
          },
        }
      )
      .pipe(
        map((response) =>
          this.accesoPublicoMapper.mapFrom(response)
        )
      );
  }
}